module.exports = __webpack_public_path__ + "static/img/liangzhan.90da040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/liangzhan.png
// module id = zy30
// module chunks = 1